import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const PageHeader4 = () => {
  const { idDomaine } = useParams();
  const [domaine, setDomaine] = useState(null);

  const Url = process.env.REACT_APP_URL_DEV;
  let publicUrl = process.env.PUBLIC_URL + '/';

  useEffect(() => {
    if (!idDomaine) {
      console.error('ID du domaine manquant !');
      return;
    }

    axios
      .get(`${Url}/api/domaine/${idDomaine}`) // ✅ même endpoint que BlocSousDomaine
      .then((res) => {
        if (res.data && res.data.data) {
          setDomaine(res.data.data);
          console.log('Domaine récupéré :', res.data.data);
        } else {
          console.error('Aucun domaine trouvé !');
        }
      })
      .catch((err) => {
        console.error('Erreur lors de la récupération du domaine :', err);
      });
  }, [idDomaine, Url]);

  return (
    <div
      className="page-header3-area"
      style={{
        backgroundImage: `url(${publicUrl}assets/img/institute/Eduma-cover-banner-17.webp)`,
      }}
    >
      <div className="container">
        <div className="page-header3-inner">
          <div className="section-title">
            {/* ✅ Affiche le nom du domaine si dispo */}
            <h2 className="page-title">
              {domaine ? domaine.domaineNom : 'Chargement...'}
            </h2>
            <ul className="page-list"></ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageHeader4;
